import type { DocumentHubNode } from './types';

/** Return the node with `id` anywhere in the tree, or null. */
export function findNode(nodes: DocumentHubNode[], id: string): DocumentHubNode | null {
  for (const node of nodes) {
    if (node.id === id) return node;
    if (node.children) {
      const found = findNode(node.children, id);
      if (found) return found;
    }
  }
  return null;
}

/** Return the chain of nodes from a root down to `targetId`, inclusive; empty if it is absent. */
export function buildPath(nodes: DocumentHubNode[], targetId: string): DocumentHubNode[] {
  function walk(current: DocumentHubNode[], path: DocumentHubNode[]): DocumentHubNode[] | null {
    for (const node of current) {
      const next = [...path, node];
      if (node.id === targetId) return next;
      if (node.children) {
        const found = walk(node.children, next);
        if (found) return found;
      }
    }
    return null;
  }
  return walk(nodes, []) ?? [];
}
